import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/tailwind.css';
import './styles/global.css';
import App from './App';
import ReactGA from "react-ga4";

// Initialize Google Analytics
ReactGA.initialize([{trackingId:'G-1E1CYP3Z3P'}]);

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
